<div class="component-wrapper">

  <div class="middle-title">
    <div class="middle-title-title">Console Comandi</div>
  </div>
  <div class="btn-container">
    @for (el of machineCommandsMapped; track el.key) {
      <button mat-raised-button color="primary" class="machine-command-btn" (click)="sendCommand(el.key)"
              [disabled]="commandsButtonsDisabled">
        <mat-icon class="machine-command-icon">{{ MachineCommandsIconEnum[el.key] }}</mat-icon>
        {{ el.value }}
      </button>
    }
  </div>
  <div class="cancel-btn-container">
    <button mat-raised-button color="accent" class="machine-command-btn" [disabled]="!commandsButtonsDisabled"
            (click)="cancelCommand()">
      <mat-icon class="machine-command-icon">cancel</mat-icon>
      Annulla comando
    </button>
  </div>
  <div class="middle-title">
    <div class="middle-title-title">Storico</div>
  </div>

  <table mat-table matSort [dataSource]="commandsHistory" class="commands-table">
    <ng-container matColumnDef="command">
      <th mat-header-cell *matHeaderCellDef>Comando</th>
      <td mat-cell *matCellDef="let row">{{ MachineCommandsEnum[row.command] ?? row.command }}</td>
    </ng-container>

    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef>Stato</th>
      <td mat-cell *matCellDef="let row">{{ MachineCommandStateEnum[row.state] }}</td>
    </ng-container>

    <ng-container matColumnDef="sentBy">
      <th mat-header-cell *matHeaderCellDef>Inviato da</th>
      <td mat-cell *matCellDef="let row">{{ row.sentBy }}</td>
    </ng-container>

    <ng-container matColumnDef="sentAt">
      <th mat-header-cell *matHeaderCellDef>Data</th>
      <td mat-cell *matCellDef="let row">{{ row.sentAt | date: 'dd/MM/yyyy HH:mm' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator
    [length]="totalCommands"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[10, 25, 50]"
    (page)="onPageChange($event)">
  </mat-paginator>
</div>



